import { CSSProperties } from "react";

import { PADDING_TARGET_ELEMENT } from "@/constants/tutorial";
import { useTutorial } from "@/lib/zustand/useTutorial/useTutorial";
import { classNames } from "@/utils/classNames";

export function OverlaySection({
  position,
}: {
  position: "top" | "left" | "right" | "bottom";
}) {
  const targetElement = useTutorial((state) => state.targetElement);

  // Should never happen, just for TypeScript
  if (targetElement === null) {
    return null;
  }

  const targetElementBoundingClientRect = targetElement.getBoundingClientRect();

  let style: CSSProperties = {};
  if (position === "top") {
    style = {
      top: 0,
      left: 0,
      right: 0,
      height: Math.max(
        targetElementBoundingClientRect.top - PADDING_TARGET_ELEMENT,
        0
      ),
    };
  } else if (position === "bottom") {
    style = {
      left: 0,
      right: 0,
      bottom: 0,
      top: Math.max(
        targetElementBoundingClientRect.bottom + PADDING_TARGET_ELEMENT,
        0
      ),
    };
  } else if (position === "left") {
    style = {
      left: 0,
      width: targetElementBoundingClientRect.left - PADDING_TARGET_ELEMENT,
      top: targetElementBoundingClientRect.top - PADDING_TARGET_ELEMENT,
      height:
        targetElementBoundingClientRect.height + PADDING_TARGET_ELEMENT * 2,
    };
  } else if (position === "right") {
    style = {
      right: 0,
      top: targetElementBoundingClientRect.top - PADDING_TARGET_ELEMENT,
      height:
        targetElementBoundingClientRect.height + PADDING_TARGET_ELEMENT * 2,
      left: targetElementBoundingClientRect.right + PADDING_TARGET_ELEMENT,
    };
  }

  return (
    <div
      className={classNames(
        "absolute bg-black bg-opacity-10 transition-opacity duration-300",
        // Fix corners
        position === "left" || position === "right" ? "overflow-y-clip" : "",
        // Before
        position === "left" || position === "right" ?
          "before:absolute before:bottom-[-50px] before:top-0 before:h-[50px] before:w-[24px] before:shadow-[0_-24px_0_0_#1118271A]"
        : "",
        position === "left" ?
          "before:right-[-24px] before:rounded-tl-[24px]"
        : "",
        position === "right" ?
          "before:left-[-24px] before:rounded-tr-[24px]"
        : "",
        // After
        position === "left" || position === "right" ?
          "after:absolute after:bottom-0 after:h-[50px] after:w-[24px] after:shadow-[0_24px_0_0_#1118271A]"
        : "",
        position === "left" ?
          "after:right-[-24px] after:rounded-bl-[24px]"
        : "",
        position === "right" ? "after:left-[-24px] after:rounded-br-[24px]" : ""
      )}
      style={style}
    />
  );
}
